import {Component} from "react";
import '../../../../style/registerPage.css';
import '../../../../style/paymentHistory.css';
import '../../../../style/inventory.css';
import {Link} from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from '../../../../api/client';
import {downloadCsv} from '../../../../utils/csvExport';
import ListPagination, {paginateItems} from '../../../CustomInputs/ListPagination';

class RoomLog extends Component {

    state = {
        logData: [],
        listPage: 1,
        pageSize: 20,
        emptyOnly: false,
    }

    readEmptyOnlyFromUrl = () => {
        const params = new URLSearchParams(window.location.search);
        // Only empty-bed report when explicitly requested (?empty=1)
        return params.get('empty') === '1';
    }

    render() {
        const title = this.state.emptyOnly ? 'گزارش تخت خالی' : 'گزارش گیری';
        const {pageItems, totalPages, page, total} = paginateItems(
            this.state.logData || [], this.state.listPage, this.state.pageSize
        );
        return (
            <>
                <div className="page-title-row">
                    <h4>{title}</h4>
                    <div className="page-actions">
                        <button type="button" className="btn btn-sm btn-outline-success" onClick={this.exportExcel}>
                            خروجی اکسل
                        </button>
                        <Link className="back-btn" to="/dashboard/booking/floor">
                            بازگشت
                            <i className="bi bi-caret-left-fill"/>
                        </Link>
                    </div>
                </div>
                <div className="table-box">
                    <table className='table'>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>طبقه</th>
                            <th>واحد</th>
                            <th>اتاق</th>
                            <th>تخت</th>
                            <th>نام اقامتگر</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            pageItems.length === 0
                                ? (
                                    <tr className="table-empty-row">
                                        <td colSpan={6}>موردی یافت نشد</td>
                                    </tr>
                                )
                                : pageItems.map((e, index) => (
                                <tr key={`${e.floor}-${e.unit}-${e.room}-${e.bed}-${index}`}>
                                    <td>{(page - 1) * this.state.pageSize + index + 1}</td>
                                    <td>{e.floor}</td>
                                    <td>{e.unit}</td>
                                    <td>{e.room}</td>
                                    <td>{e.bed}</td>
                                    <td>{e.ownerFullName || '—'}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </div>
                <div className="text-muted small text-center mt-2">
                    نمایش {pageItems.length ? ((page - 1) * this.state.pageSize + 1) : 0}
                    –{(page - 1) * this.state.pageSize + pageItems.length} از {total}
                </div>
                <ListPagination
                    page={page}
                    totalPages={totalPages}
                    onNewPage={(p) => this.setState({listPage: p})}
                />
            </>
        );
    }

    exportExcel = () => {
        downloadCsv(this.state.emptyOnly ? 'empty-beds.csv' : 'beds-report.csv', ['طبقه', 'واحد', 'اتاق', 'تخت', 'نام اقامتگر'], (this.state.logData || []).map((e) => [
            e.floor, e.unit, e.room, e.bed, e.ownerFullName || '',
        ]));
    }

    bedLogEndpoint = () => (
        this.state.emptyOnly
            ? `${API_BASE_URL}/api/v1/supervisor/bed/concat/empty`
            : `${API_BASE_URL}/api/v1/supervisor/bed/concat/all`
    );

    async componentDidMount() {
        const emptyOnly = this.readEmptyOnlyFromUrl();
        this.setState({emptyOnly}, () => this.fetchLogData());
    }

    fetchLogData = () => {
        const url = this.bedLogEndpoint();
        axios.get(url, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => this.setState({logData: this.normalizeLogData(data), listPage: 1}))
            .catch(() => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.get(url, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => this.setState({logData: this.normalizeLogData(data), listPage: 1}))
                            } else {
                                window.location = '/'
                            }
                        })
                } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                    axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.get(url, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                    .then((data) => this.setState({logData: this.normalizeLogData(data), listPage: 1}))
                            } else {
                                window.location = '/'
                            }
                        })
                }})

    }

    normalizeLogData = (data) => {
        const rows = this.sortLogData(Array.isArray(data) ? data : []);
        if (this.state.emptyOnly) {
            return rows;
        }
        return rows.filter((e) => String(e.ownerFullName || '').trim());
    }

    sortLogData = (data) => {
        return [...(data || [])].sort((a, b) => {
            const unitCmp = String(a.unit ?? '').localeCompare(String(b.unit ?? ''), undefined, {numeric: true});
            if (unitCmp !== 0) return unitCmp;
            return String(a.room ?? '').localeCompare(String(b.room ?? ''), undefined, {numeric: true});
        });
    }

}

export default RoomLog;
